import { ReactElement } from 'react';
import { FormRow } from '@op/opds.opux';
import { Stepper } from '@op/opds.opux-stepper';
import { decreaseRoundedValue, increaseRoundedValue } from '../../utils';

interface ListItemProps {
  label: string;
  value: number;
  onChange: (value: string) => void;
}

const SavingsInput = ({ label, value, onChange }: ListItemProps): ReactElement => {
  return (
    <div className="savingsinput">
      <FormRow label={label} className="investoracademy-calculator-labels">
        <div className="investoracademy-stepper-container">
          <Stepper
            size="small"
            min={0}
            max={10000}
            largeStepMultiplier={10}
            unit="€"
            value={value}
            className="investoracademy-calculator-stepper"
            onChange={(newValue: number) => {
              return onChange(newValue.toString());
            }}
            onClickIncrease={() => {
              onChange(String(increaseRoundedValue(value, 10)));
            }}
            onClickDecrease={() => {
              onChange(String(decreaseRoundedValue(value, 10)));
            }}
          />
        </div>
      </FormRow>
    </div>
  );
};

export default SavingsInput;
